import apiClient from '@/utils/api-client'

class CpayService {
    public getPaymentUrl(planId: string) {
        return new Promise<string>((resolve, reject) => {
            apiClient.get('/api/v1/cpay/checkout-url/' + planId).then((res) => {
                if (res.status == 200 && res.data != null) {
                    if (res.data.status == 6032) {
                        resolve(res.data.url)
                    } else {
                        resolve("false")
                    }
                } else {
                    resolve("false")
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }

    public getOrderId(planId: string): Promise<number> {
        console.log("getOrderId");
        return new Promise<number>((resolve, reject) => {
            apiClient.get(`/api/v1/cpay/get-order-id/${planId}`)
                .then((res) => {
                    if (res.status === 200 && res.data != null) {
                        resolve(res.data);
                    } else {
                        reject("No order id returned");
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default new CpayService()
